import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../constants/rentalPortal'
import { PROFILE_ROUTE_NAMES } from '../../../../constants/route'
import { formatNumberWithSeparators } from '../../../../utils/number'
import {
  getListingRentDisplayValue,
  toListingFlatNumber,
} from '../../../RentalPortalListing'
import { getApplicantShortDate } from '../RentalPortalApplicantProfileHeaderInfoItems'

export function getApplicantMatchedListingFacts({ matchedListing, t }) {
  return [
    matchedListing?.flat?.room_count == null
      ? null
      : t('RentalPortal.ListingFormFlatFactsRoomsKey', {
          count: toListingFlatNumber(matchedListing.flat.room_count),
        }),
    Number.isFinite(matchedListing?.flat?.area)
      ? `${formatNumberWithSeparators(matchedListing.flat.area)} ${t('Common.AreaUnitKey')}`
      : null,
    matchedListing?.rent_price == null
      ? null
      : t('RentalPortal.ApplicantProfileMatchedListingRentKey', {
          rent: getListingRentDisplayValue(matchedListing),
        }),
    matchedListing?.available_from
      ? t('RentalPortal.ApplicantProfileMatchedListingAvailableFromKey', {
          date: getApplicantShortDate(matchedListing.available_from),
        })
      : null,
  ]
    .filter(Boolean)
    .join(RENTAL_PORTAL_FACT_SEPARATOR)
}

export function getApplicantMatchedListingUrl(matchedListing) {
  return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
    id: matchedListing?.id,
  })
}
